var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../lib";
export class ApiSmpAccountCredentials {
}
_a = ApiSmpAccountCredentials;
/**
 * Used to connect AccountCredential via Credential
 */
ApiSmpAccountCredentials.connect = (credential) => apiRequest({
    body: credential,
    endpoint: REACT_APP__URL_SMP_API + "/account-credentials/v1/connect",
    method: "POST",
});
/**
 * Used to disconnect AccountCredential by id
 */
ApiSmpAccountCredentials.destroy = ({ id, }) => apiRequest({
    endpoint: `${REACT_APP__URL_SMP_API}/account-credentials/v1/credential/${id}`,
    method: "DELETE",
});
/**
 * Used to get AccountCredentials list
 */
ApiSmpAccountCredentials.list = (req) => __awaiter(void 0, void 0, void 0, function* () {
    return yield apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/account-credentials/v1/credential/`,
        method: "GET",
        next: req === null || req === void 0 ? void 0 : req.next,
        query: req === null || req === void 0 ? void 0 : req.query,
    });
});
/**
 * Used to get AccountCredential by id
 */
ApiSmpAccountCredentials.retrieve = (req) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_SMP_API}/account-credentials/v1/credential/${req.path.id}`,
        method: "GET",
    });
});
/**
 * Used to update AccountCredential partially by id
 */
ApiSmpAccountCredentials.updatePartial = ({ id, smpAccountCredentialPartial, }) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        body: smpAccountCredentialPartial,
        endpoint: `${REACT_APP__URL_SMP_API}/account-credentials/v1/credential/${id}`,
        method: "PATCH",
    });
});
//# sourceMappingURL=account_credentials.js.map